var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linha-quadrado-wrapper"},_vm._l((_vm.arBlocos),function(_,index){return _c('div',{key:index,class:['linha-quadrado', (_vm.classe + "-linha"), { animacaoLinha: index <= _vm.contagem }]})}))}
var staticRenderFns = []

export { render, staticRenderFns }